import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import LeftSideContainer from "components/Collabration/LeftSideContainer";
import RightSideContainer from "components/Collabration/RightSideContainer";
import { useAuth } from "context/AuthContext";
import { useDispatch } from "react-redux";
import MeetModal from "components/MeetModal";


// Images
import ArrowLeftIcon from "images/arrow-left-icon.svg";
import { getForumDetails } from "../../api/collaborativeForum/index";
import { dispatch } from "d3";
import { setIsMeetAgentModalOpen } from "slices/chat/reducer";
import { triggerMeetAutomateThunk } from "slices/chat/thunk";
import { notifySuccess } from "utils/customToasts";

const CollabrativeForumDetail = () => {
  const [data, setData] = useState({ comments: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [searchParams] = useSearchParams();
  const forumId = searchParams.get("forum_id");
  const dispatch = useDispatch();
  const { user } = useAuth();
  const userId = user?._id;

  const fetchForumData = async () => {
    setLoading(true);
    try {
      const payload = { forumId };
      const response = await getForumDetails(payload);
      setData(response.data);
    } catch (err) {
      console.log("Error:", err);
    } finally {
      setLoading(false);
    }
  };

const handleMeetButtonClick = () => {
  dispatch(setIsMeetAgentModalOpen(true));
      dispatch(
        triggerMeetAutomateThunk({
          prompt: "Initiate meet agent automation",
          user_id: userId,
          members: [],
        })
      );
};


  const onAddComment = (comment) => {
    const newCommentPayload = {
      forum_id: forumId,
      comment: comment,
      timestamp: new Date(),
      user_name: "You",
    };

    setData((prev) => {
      return {
        ...prev,
        comments: [...prev.comments, newCommentPayload],
      };
    });
  };

  useEffect(() => {
    fetchForumData();
    return () => {
      setData({});
    };
  }, [forumId]);

  if (loading) {
    return <div className="text-white text-center mt-10">Loading...</div>;
  }

  if (error) {
    return (
      <div className="text-red-500 text-center mt-10">
        Error: {error?.message}
      </div>
    );
  }

  if (!data) {
    return (
      <div className="text-white text-center mt-10">No data available</div>
    );
  }

  return (
    <div className="p-10">
      <div className="flex items-center justify-between py-4 px-3 border-b border-[#BEEF9E66]">
        <h1 className="flex gap-4 items-center font-medium text-2xl">
          <Link to={`/collaborative-forum`} className="cursor-pointer">
            <img src={ArrowLeftIcon} alt="Back" />
          </Link>
          Collaborative forum
        </h1>

        <button onClick={handleMeetButtonClick} className="bg-[#7A5AF8] text-white px-4 py-2 rounded-md text-base font-medium hover:bg-[#684ee0] transition">
          Schedule a Meeting
        </button>
      </div>

      <div className="grid grid-cols-12 gap-6 mt-8">
        <LeftSideContainer
          data={data}
          forumId={forumId}
          onAddComment={onAddComment}
        />
        <RightSideContainer data={data} forumId={forumId} />
      </div>
      <MeetModal />
    </div>
  );
};

export default CollabrativeForumDetail;
